import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckAwtgRanDetails } from '@api/hitoryCheck';

import { TAwtgRanDetailsDTO, TAwtgRanDetailsResponse } from '@interfaces/cmModule/dto/historyCheckDTO';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_DETAILS_RAN } from '@constants/queryKeys';

interface IUseQueryHistoryCheckAwtgRanDetailsReturnValue {
	historyDetails?: TAwtgRanDetailsResponse;
	isLoadingDetails: boolean;
	isFetchingDetails: boolean;
}

export const useQueryHistoryCheckAwtgRanDetails = (
	params: TAwtgRanDetailsDTO & { isAwtgRanVendor?: boolean },
): IUseQueryHistoryCheckAwtgRanDetailsReturnValue => {
	const {
		data: historyDetails,
		isLoading: isLoadingDetails,
		isFetching: isFetchingDetails,
	} = useQuery<TAwtgRanDetailsResponse>({
		queryKey: [HISTORY_CHECK_DETAILS_RAN, params],
		queryFn: () => getHistoryCheckAwtgRanDetails({
			dataModelPathId: params.dataModelPathId,
			dumpHistoryId: params.dumpHistoryId,
			managedObjects: params.managedObjects,
			networkElementName: params.networkElementName,
			page: params.page,
			pageSize: params.pageSize,
			paramSearchValue: params.paramSearchValue,
			sortDirection: params.sortDirection,
			sortFieldName: params.sortFieldName,
		}),
		enabled: [!!params?.dumpHistoryId && !!params?.dataModelPathId && !!params?.isAwtgRanVendor],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		historyDetails,
		isLoadingDetails: isLoadingDetails || isFetchingDetails,
		isFetchingDetails,
	};
};
